const QR_SIZE = 200;

export { QR_SIZE };
